export async function videoUrlIsHealthy(
  url: string,
  fetcher: typeof fetch = fetch,
  signal?: AbortSignal
) {
  let parsed: URL;
  try { parsed = new URL(url, window.location.origin); } catch { return false; }
  const isLocalVideo = parsed.origin === window.location.origin && parsed.pathname.startsWith("/media/video/") && parsed.pathname.toLowerCase().endsWith(".mp4");
  const isExternalVideo = parsed.protocol === "https:" && parsed.origin !== window.location.origin && parsed.pathname.toLowerCase().endsWith(".mp4");
  if (!isLocalVideo && !isExternalVideo) return false;
  const healthTarget = isExternalVideo ? parsed.toString() : parsed.pathname;
  try {
    const response = await fetcher(`/api/video/health?url=${encodeURIComponent(healthTarget)}`, { cache: "no-store", signal });
    if (!response.ok) return false;
    const result = await response.json() as { ok?: boolean; contentType?: string };
    return result.ok === true && result.contentType === "video/mp4";
  } catch { return false; }
}